<template>
  <div class="page text-center">
    <h1 class="landing-title">{{errorCode}}</h1>
    <h3 class="landing-subtitle">{{errorText}}</h3>
    <p class="long-error">{{longErrorMessage}}</p>
  </div>
</template>

<script>
export default {
  props: {
    errorText: {
      type: String,
      default: 'Not Found'
    },
    errorCode: {
      type: String,
      default: '404'
    },
    longErrorMessage: {
      type: String,
      default: ''
    },
  },
};
</script>

<style scoped>
  .long-error {
    margin: 0;
    font-size: 2rem;
  }
</style>